import { createReducer } from "@reduxjs/toolkit";
import {
  forgotPasswordSendEmail,
  forgotPasswordSendEmailFailure,
  forgotPasswordSendEmailSuccess,
  forgotPasswordReset,
  forgotPasswordRestoreFailure,
  forgotPasswordRestoreSuccess,
  forgotPasswordRestore,
  toggleForgotPasswordModal,
} from "./actions";

const initialState = {
  isLoading: false,
  isSuccess: false,
  isTokenValid: false,
  error: null,
  isForgotPasswordModalVisible: false,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(forgotPasswordSendEmail.type, (state) => ({
      ...state,
      isSuccess: false,
      isLoading: true,
    }))
    .addCase(forgotPasswordSendEmailSuccess.type, (state) => ({
      ...state,
      isLoading: false,
      isSuccess: true,
    }))
    .addCase(forgotPasswordSendEmailFailure.type, (state, action) => ({
      ...state,
      isSuccess: false,
      isLoading: false,
      error: action.payload,
    }))
    .addCase(forgotPasswordRestore.type, (state) => ({
      ...state,
      isLoading: true,
      error: null,
    }))
    .addCase(forgotPasswordRestoreSuccess.type, (state) => ({
      ...state,
      isSuccess: true,
      isLoading: false,
    }))
    .addCase(forgotPasswordRestoreFailure.type, (state, action) => ({
      ...state,
      isLoading: false,
      error: action.payload,
    }))
    .addCase(toggleForgotPasswordModal, (state, action) => ({
      ...state,
      isForgotPasswordModalVisible: action.payload,
    }))
    .addCase(forgotPasswordReset.type, (_, { payload }) => ({
      ...initialState,
      ...(payload || {}),
    }));
});
